const env = {}

env.baseURL = 'https://api.ponto-hml.it4d.com.br/api/v1/'
env.normalURL = 'https://api.ponto-hml.it4d.com.br/'

export default env
